import { QueryClientProvider } from '@tanstack/react-query'

import { CartPromoCmsBlock } from './CartPromoCmsBlock'
import { ItemsByDiscount } from './ItemsByDiscount'
import { ProgressBar } from './ProgressBar'
import { getQueryClient } from '../../../../Infrastructure'
import { CheckoutProvider } from '../../../Checkout'
import { UiProvider } from '../../../Theme'
import { PromoProvider } from '../../state'


/**
 * PromoCart - Entry point for the promo-in-cart feature.
 *
 * Wraps with QueryClientProvider > CheckoutProvider > PromoProvider.
 * All child components read from PromoProvider context (no props).
 */
export function PromoCart() {
  const queryClient = getQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <UiProvider>
        <CheckoutProvider>
          <PromoProvider>
            <div className="flex flex-col gap-5">
              <ProgressBar />
              <CartPromoCmsBlock />
              <ItemsByDiscount />
            </div>
          </PromoProvider>
        </CheckoutProvider>
      </UiProvider>
    </QueryClientProvider>
  )
}
